import React from 'react';

export const DropUpdown = () => {
    return(
        <svg className='[@media(max-width:767px)]:!w-[21px] m-auto' width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http:www.w3.org/2000/svg">
            <path d="M22 27.9668L0 5.96683L5.13333 0.833496L22 17.7002L38.8667 0.833496L44 5.96683L22 27.9668Z" className='dark:fill-[#FFF]' fill="#07091B" />
        </svg>
    )
}